import { render, staticRenderFns } from "./StatisticsCards.vue?vue&type=template&id=4c341a16&scoped=true&"
import script from "./StatisticsCards.vue?vue&type=script&lang=ts&"
export * from "./StatisticsCards.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsCards.vue?vue&type=style&index=0&id=4c341a16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c341a16",
  null
  
)

export default component.exports